import POST_COMPONENT_TYPE from '../postComponentType';
import EggFreezingHero from '../../../assets/images/social-egg-freezing-hero-section.png';
import { IconType } from '../../../components/BannerWithList';

const socialEggFreezingData = {
  key: 'social-egg-freezing',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.social-egg-freezing.infoBanner.title',
    },
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.social-egg-freezing.name',
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: EggFreezingHero,
      text: 'learnMoreContent.social-egg-freezing.banner.text',
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.social-egg-freezing.purpose.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.social-egg-freezing.purpose.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.social-egg-freezing.purpose.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.social-egg-freezing.purpose.listItem3',
              type: 'text',
            },
            {
              text: 'learnMoreContent.social-egg-freezing.purpose.listItem4',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.social-egg-freezing.consideration.title',
      description: {
        text: 'learnMoreContent.social-egg-freezing.consideration.description',
        type: 'text',
      },
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.social-egg-freezing.howItWorks.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.social-egg-freezing.howItWorks.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.social-egg-freezing.howItWorks.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.social-egg-freezing.howItWorks.listItem3',
              type: 'text',
            },
            {
              text: 'learnMoreContent.social-egg-freezing.howItWorks.listItem4',
              type: 'text',
            },
            {
              text: 'learnMoreContent.social-egg-freezing.howItWorks.listItem5',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.social-egg-freezing.age.title',
      description: {
        text: 'learnMoreContent.social-egg-freezing.age.description',
        type: 'text',
      },
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.social-egg-freezing.cost.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.social-egg-freezing.cost.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.social-egg-freezing.cost.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.social-egg-freezing.cost.listItem3',
              type: 'text',
            },
            {
              text: 'learnMoreContent.social-egg-freezing.cost.listItem4',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.social-egg-freezing.limitation.title',
      iconType: IconType.WARNING,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.social-egg-freezing.limitation.listItem1',
              type: 'text',
            },
          ],
        },
      ],
    },
  ],
};

export default socialEggFreezingData;
